import React, {Component} from 'react';
import {connect} from 'react-redux';
import MainBanners from './MainBanners';
import {fetchPcBangNotices} from '../../actions/notices.actions';
import {fetchPcBangMainBanners} from '../../actions/mainBanners.actions';
import HeaderMenu from '../Common/HeaderMenu';
import Footer from '../Common/Footer';
import './main.scss';
import {MainMenus} from './MainMenus';
import {MainNotices} from './MainNotices';
import {MainCustomerCenter} from './MainCustomerCenter';
import {MainGames} from './MainGames';

const stateToProps = state => {
  return {
    mainBanners: state.mainBanners,
    notices: state.notices.data,
  };
};

class Main extends Component {
  componentDidMount() {
    this.props.dispatch(fetchPcBangNotices(1, 9));
    this.props.dispatch(fetchPcBangMainBanners());
  }

  render() {
    const {notices, mainBanners} = this.props;
    return (
      <div className="pcbang-main">
        <HeaderMenu />
        <MainBanners mainBanners={mainBanners} />
        <div className="pcbang-main__inner">
          <MainMenus />
          <div className="main-block">
            <div className="main-block__inner">
              <MainNotices notices={notices} />
              <MainCustomerCenter />
            </div>
            <MainGames />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default connect(stateToProps)(Main);
